export class Environments {

    public static readonly DEV = "dev";
    public static readonly PREPROD = "preprod";
    public static readonly PROD = "prod";
}
